
export const openHouse = {
  title: "Dia de Portas Abertas",
  description: "Junte-se a nós para descobrir nossa escola!",
  subtitle: "Esperamos mostrar a você por que a Gándara é a escolha ideal para o futuro acadêmico do seu filho!",
  bookVisit: "Agende sua visita",
  lastSpots: "Últimas vagas disponíveis para o nosso próximo Dia de Portas Abertas! Reserve agora!",
  discover: {
    title: "Descubra a Gándara International School",
    description: "com uma visita personalizada mediante reserva, a partir da primeira semana de setembro."
  },
  methodology: {
    title: "Na Gándara, acreditamos na aprendizagem personalizada",
    description: "adaptada a cada aluno, e no desenvolvimento de habilidades para um mundo global."
  },
  flexibility: {
    title: "Nossas portas estão abertas para você todos os dias!",
    description: "Entendemos que os horários familiares podem ser complicados, por isso oferecemos máxima flexibilidade para que você nos visite em qualquer dia."
  }
};
